module.exports = __webpack_public_path__ + "static/media/price-fifth.795806c2.png";